const hasMinWidthOf = (size: 'ms' | 'md' | 'xl'): boolean => {
  const minWidth = { ms: '768', md: '992', xl: '1200' }[size]
  return window.matchMedia && window.matchMedia(`(min-width: ${minWidth}px)`).matches
}

export default hasMinWidthOf
